<template>
  <div v-if="submitted" class="mb-3">
    <h4>
      {{ value.question.title }}
      <v-icon
        v-if="!value.question.optional"
        :color="themes.candidate.light.muted"
        class="text-vertical-super"
        small
      >
        mdi-asterisk
      </v-icon>
    </h4>
    <pre v-html="value.answer.content" class="grey--text text--darken-2" />
  </div>
  <div v-else class="mb-3">
    <h4>
      {{ value.question.title }}
      <v-icon
        v-if="!value.question.optional"
        :color="themes.candidate.light.muted"
        class="text-vertical-super"
        small
      >
        mdi-asterisk
      </v-icon>
    </h4>
    <v-textarea
      placeholder="Answer"
      v-model="answer.content"
      :required="!value.question.optional"
      @input="save"
      :rows="rows"
      :color="themes.candidate.light.input"
      auto-grow
      :loading="loading"
      :hint="
        value.question.wordLimit > 0
          ? `Maximum of ${value.question.wordLimit} words (${words}/${value.question.wordLimit})`
          : null
      "
      :error-messages="
        value.question.wordLimit && words > value.question.wordLimit
          ? 'You have exceeded the word limit for this question!'
          : null
      "
    />
  </div>
</template>

<script>
import _ from "lodash";

// Vue Component
export default {
  props: {
    value: Object,
    submitted: Boolean,
  },
  data() {
    return {
      loading: false,
      answer: JSON.parse(JSON.stringify(this.value.answer)) || {},
    };
  },
  computed: {
    rows() {
      return this.answer.content ? this.answer.content.split(/\n/).length : 1;
    },
    words() {
      if (typeof this.answer.content !== "string") return 0;
      return (
        (this.answer.content || "").match(/([a-zA-Z0-9_\-'’,.])+/gm) || []
      ).length;
    },
  },
  methods: {
    save(content) {
      // Don't save answers longer than the word limit
      if (
        this.value.question.wordLimit &&
        this.words > this.value.question.wordLimit
      )
        return;
      this.answer.id ? this.update(content) : this.create(content);
    },

    create: _.debounce(function (content) {
      this.toggleLoading();
      this.$http
        .post("candidate/answers", { answer: { ...this.answer, content } })
        .then((response) => {
          this.answer.id = response.data.id;
          this.updateAnswer(response.data);
          this.toggleLoading();
        });
    }, 500),

    update: _.debounce(function (content) {
      this.toggleLoading();
      if (this.answer.id) {
        this.$http
          .patch(`candidate/answers/${this.answer.id}`, {
            answer: { ...this.answer, content },
          })
          .then((response) => {
            this.updateAnswer(response.data);
            this.toggleLoading();
          });
      }
    }, 500),

    toggleLoading() {
      if (this.loading) {
        this.$emit("saved");
        this.loading = false;
      } else {
        this.$emit("saving");
        this.loading = true;
      }
    },

    updateAnswer: _.debounce(function (answer) {
      // When value has no answer
      if (!this.value.answer) {
        this.value.answer = answer;
        return;
      }

      // When content is out of sync with api
      if (this.answer.content !== answer.content) {
        this.save(this.answer.content);
        return;
      }

      // Update answer
      this.answer = { ...this.answer, ...answer };
    }, 5000),
  },
};
</script>

<style scoped>
pre {
  font-family: "Heebo";
  white-space: pre-line;
}
</style>
